import type { ResultType } from '@/pages/YangbokOrg/questionFormTypes';

export const JEWELRY_RESULT_TYPES: ResultType[] = [
  {
    key: 'luxuryBrand',
    title: '브랜드 시그니처형',
    recommendation: '백화점 명품 브랜드',
    summary: '상징성과 브랜드 경험을 가장 중요하게 보는 타입이에요.',
    rarityPercent: 18,
    typeExplanation: {
      summary:
        '두 분의 반지를 하나의 상징으로 남기고 싶고, 브랜드가 주는 안정감과 정찰제 경험을 선호하는 타입이에요.',
      paragraphs: [
        '명품 브랜드는 디자인 선택지가 제한적일 수 있지만, 브랜드 가치와 구매 경험이 명확합니다.',
        '가격 조율은 어렵기 때문에 예산 범위를 먼저 정하고, 웨딩 마일리지나 백화점 혜택까지 함께 비교하는 방식이 좋아요.',
        '같은 디자인을 착용하는 커플이 있을 수 있다는 점은 미리 감안해야 합니다.',
      ],
    },
    styleBars: [
      { label: '브랜드 상징성', level: '매우 높음', value: 95 },
      { label: '구매 안정감', level: '높음', value: 82 },
      { label: '커스터마이징', level: '낮음', value: 28 },
      { label: '가격 조율 여지', level: '낮음', value: 20 },
      { label: '디자인 희소성', level: '보통', value: 48 },
    ],
    mainRecommendation: {
      title: '백화점 명품 브랜드',
      description:
        '브랜드의 상징성과 구매 경험을 중요하게 본다면 백화점 명품 브랜드 라인이 잘 맞습니다. 가격 협상보다는 예산 내에서 가장 오래 만족할 디자인을 고르는 것이 핵심입니다.',
      reasons: [
        '브랜드 가치와 상징성이 명확합니다.',
        '정찰제라 비교 기준이 단순합니다.',
        '백화점 웨딩 마일리지와 연계 혜택을 활용할 수 있습니다.',
        '오래 봐도 안정적인 대표 디자인을 선택하기 좋습니다.',
      ],
    },
    upgradeConditions: [
      '예산보다 브랜드 경험과 상징성이 더 중요함',
      '백화점 웨딩 마일리지를 다른 혼수와 함께 활용할 계획',
      '커스터마이징보다 검증된 대표 디자인을 선호',
    ],
    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '명품 브랜드 웨딩밴드',
        description:
          '상징성과 안정감을 우선한다면 대표 디자인을 중심으로 비교하는 것이 좋습니다.',
        highlight: true,
      },
      {
        tag: '주의할 점',
        title: '디자인 중복 가능성',
        description:
          '인기 디자인은 착용 커플이 많을 수 있어 희소성을 원한다면 일반 예물샵도 함께 보세요.',
      },
      {
        tag: '예산 관리',
        title: '마일리지 포함 비교',
        description:
          '반지 가격만 보지 말고 백화점 혜택과 다른 혼수 구매 계획까지 함께 계산하세요.',
      },
    ],
    matchedShopIds: ['v1', 'v2'],
  },
  {
    key: 'cheongdamDesign',
    title: '청담 디자인형',
    recommendation: '청담 디자인 예물샵',
    summary: '디자인과 상담 경험, 부속 혜택까지 함께 보는 타입이에요.',
    rarityPercent: 27,
    typeExplanation: {
      summary:
        '무난한 커플링보다 두 분의 분위기에 맞는 디자인과 세팅을 중요하게 보는 타입이에요.',
      paragraphs: [
        '청담 라인은 디자인 제안과 부속 서비스가 강한 편이라 하루 투어로 여러 매장을 비교하기 좋습니다.',
        '티아라, 헤어소품, 혼주 액세서리 같은 서비스가 계약 조건에 포함되는지 확인하면 실제 체감 혜택을 판단하기 쉬워요.',
        '당일계약 혜택이 강할 수 있으므로 최소 2곳 이상 비교 후 결정하는 편이 안전합니다.',
      ],
    },
    styleBars: [
      { label: '디자인 다양성', level: '매우 높음', value: 92 },
      { label: '상담 경험', level: '높음', value: 84 },
      { label: '부속 혜택', level: '높음', value: 78 },
      { label: '가격 효율성', level: '보통', value: 55 },
      { label: '커스터마이징', level: '높음', value: 72 },
    ],
    mainRecommendation: {
      title: '청담 디자인 예물샵',
      description:
        '유니크한 디자인과 부속 혜택을 함께 보고 싶다면 청담 예물샵 투어가 잘 맞습니다. 디자인 완성도와 계약 혜택을 동시에 비교하세요.',
      reasons: [
        '디자인 제안 폭이 넓습니다.',
        '티아라·소품·혼주 액세서리 혜택을 함께 받을 수 있습니다.',
        '하루에 여러 매장을 비교하기 좋습니다.',
        '상담 경험과 완성도 중심으로 고르기 좋습니다.',
      ],
    },
    upgradeConditions: [
      '반지 외 부속 서비스까지 중요함',
      '하루 투어로 여러 매장을 비교하고 싶음',
      '유니크한 디자인이나 화려한 세팅을 선호',
    ],
    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '청담 예물 투어',
        description:
          '디자인과 부속 혜택을 함께 비교하기 좋은 방식입니다.',
        highlight: true,
      },
      {
        tag: '계약 전 확인',
        title: '서비스 포함 범위',
        description:
          '티아라, 소품, 각인, 혼주 액세서리가 견적에 어떻게 포함되는지 확인하세요.',
      },
      {
        tag: '비교 기준',
        title: '당일계약 압박 주의',
        description:
          '혜택이 커 보여도 최소 2곳 이상 견적을 본 뒤 결정하는 편이 좋습니다.',
      },
    ],
    matchedShopIds: ['v2', 'v3'],
  },
  {
    key: 'jongnoValue',
    title: '종로 실속형',
    recommendation: '종로 가성비 예물샵',
    summary: '예산 효율과 금 함량을 현실적으로 비교하는 타입이에요.',
    rarityPercent: 31,
    typeExplanation: {
      summary:
        '브랜드보다 실제 금 함량, 세공비, 견적 조건을 꼼꼼히 비교해서 합리적으로 고르고 싶은 타입이에요.',
      paragraphs: [
        '종로 라인은 발품을 팔수록 견적 차이를 확인하기 쉬워 예산 효율을 중시하는 분께 잘 맞습니다.',
        '다만 매장별 설명 방식과 견적 구성 차이가 크므로 금 함량, 중량, 세공비, 다이아 등급을 같은 기준으로 비교해야 합니다.',
        '부속 서비스는 청담보다 적을 수 있지만 반지 본체의 가격 경쟁력이 좋은 편입니다.',
      ],
    },
    styleBars: [
      { label: '가격 효율성', level: '매우 높음', value: 95 },
      { label: '견적 비교 필요도', level: '매우 높음', value: 88 },
      { label: '금 함량 중시', level: '높음', value: 80 },
      { label: '브랜드 상징성', level: '낮음', value: 30 },
      { label: '부속 혜택', level: '보통', value: 45 },
    ],
    mainRecommendation: {
      title: '종로 가성비 예물샵',
      description:
        '예산 안에서 금 함량과 디자인을 최대한 챙기고 싶다면 종로 라인이 현실적입니다. 같은 조건으로 견적표를 비교하는 것이 핵심입니다.',
      reasons: [
        '예산 대비 금 함량을 높이기 좋습니다.',
        '여러 매장을 비교하며 견적 차이를 확인할 수 있습니다.',
        '심플 페어링 구성에서 가격 경쟁력이 좋습니다.',
        '디자인보다 실속을 우선할 때 만족도가 높습니다.',
      ],
    },
    upgradeConditions: [
      '여러 곳을 직접 비교할 시간이 있음',
      '브랜드보다 금 함량과 실구매가가 중요함',
      '부속 서비스보다 반지 본체에 예산을 쓰고 싶음',
    ],
    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '종로 견적 비교',
        description:
          '실속을 우선한다면 같은 조건으로 2~3곳 견적을 비교하세요.',
        highlight: true,
      },
      {
        tag: '비교 항목',
        title: '금 함량·중량·세공비',
        description:
          '디자인명보다 실제 금 중량과 세공비 포함 여부를 확인하는 것이 중요합니다.',
      },
      {
        tag: '대안',
        title: '심플 커스터마이징',
        description:
          '예산을 조금 더 쓰면 금 함량을 높이거나 각인, 표면 마감을 조율할 수 있습니다.',
      },
    ],
    matchedShopIds: ['v1', 'v3'],
  },
  {
    key: 'customBand',
    title: '커스터마이징 밴드형',
    recommendation: '18K 중심 맞춤 커플링',
    summary: '일상 착용과 두 분만의 디테일을 함께 중요하게 보는 타입이에요.',
    rarityPercent: 24,
    typeExplanation: {
      summary:
        '매일 착용해도 부담 없고, 오래 봐도 질리지 않는 밴드에 두 분만의 디테일을 담고 싶은 타입이에요.',
      paragraphs: [
        '착용 빈도가 높다면 디자인보다 착용감, 금 함량, 세팅 안정성이 중요해집니다.',
        '18K 심플 밴드에 작은 다이아, 각인, 표면 마감 차이를 더하면 과하지 않으면서도 두 분만의 반지를 만들 수 있어요.',
        '상담 시에는 손 모양과 생활 패턴에 맞춰 폭, 두께, 라운딩 정도를 직접 비교해보는 것이 좋습니다.',
      ],
    },
    styleBars: [
      { label: '일상 착용성', level: '매우 높음', value: 94 },
      { label: '커스터마이징', level: '매우 높음', value: 90 },
      { label: '금 함량 중시', level: '높음', value: 82 },
      { label: '디자인 안정감', level: '높음', value: 78 },
      { label: '브랜드 상징성', level: '낮음', value: 34 },
    ],
    mainRecommendation: {
      title: '18K 중심 맞춤 커플링',
      description:
        '매일 착용할 반지라면 18K 밴드를 중심으로 착용감과 디테일을 조율하는 방식이 잘 맞습니다. 유행보다 오래 만족할 균형을 잡는 것이 중요합니다.',
      reasons: [
        '상시 착용에 맞춰 내구성과 착용감을 챙길 수 있습니다.',
        '각인, 마감, 다이아 포인트를 세밀하게 조율할 수 있습니다.',
        '유행을 덜 타는 디자인으로 오래 착용하기 좋습니다.',
        '예산을 브랜드보다 소재와 완성도에 집중할 수 있습니다.',
      ],
    },
    upgradeConditions: [
      '반지를 거의 매일 착용할 계획',
      '두 분만의 각인이나 디자인 디테일을 원함',
      '화려함보다 착용감과 오래 볼 디자인이 중요함',
    ],
    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '18K 맞춤 밴드',
        description:
          '일상 착용성과 두 분만의 의미를 함께 챙기기 좋은 선택입니다.',
        highlight: true,
      },
      {
        tag: '상담 포인트',
        title: '폭·두께·라운딩',
        description:
          '같은 디자인도 손에 올렸을 때 느낌이 달라 직접 착용 비교가 중요합니다.',
      },
      {
        tag: '디테일',
        title: '각인과 표면 마감',
        description:
          '무광, 유광, 해머드, 작은 다이아 포인트로 과하지 않게 차이를 만들 수 있습니다.',
      },
    ],
    matchedShopIds: ['v2', 'v3'],
  },
];
